const Footer = () => {
    return (
        <footer >
            <div className="madurai-container">
                <p className="footer-text">
                    Blessings of Shri Meenakshi Amman Temple 🙏
                </p>
                <div className="border-art"></div>
            </div>
        </footer>
    );
};

export default Footer;